import { LooseItemsList } from './LooseItemsList';

export default LooseItemsList;
